import { create_api } from './base';

export default class CustomerProfileRepo {
  // no-dd-sa:javascript-best-practices/no-unreachable
  baseUrl = '/customer-profile';

  constructor() {
    this.api = create_api(import.meta.env.REACT_APP_API_ROOT);
  }

  get = (id) => this.api.get(`${this.baseUrl}/${id}`).then((r) => r.data);
  correctAddress = (id, shipmentId, address, addressOnly) => {
    const params = { shipment_id: shipmentId };
    if (addressOnly) params.address_only = true;
    return this.api.post(`${this.baseUrl}/${id}/correct-address`, address, { params }).then((r) => r.data);
  };
  deliveryHistory = (id) => this.api.get(`${this.baseUrl}/${id}/delivery-history`).then((r) => r.data);
  update = (profile) => this.api.put(`${this.baseUrl}/${profile.id}`, profile);
}
